<template>
    <c-dialog
            ref="dialog"
            title="选择人员"
            width="1200"
            height="500"
            @resolve="confirmSelection"
    >

        <page>
            <module enable-flex>
                <m-search ref="search" @search="searchHandle">
                    <m-search-item label="账号">
                        <c-input name="user_name"></c-input>
                    </m-search-item>
                    <m-search-item label="姓名">
                        <c-input name="user_realname"></c-input>
                    </m-search-item>
                    <m-search-item label="手机号码">
                        <c-input name="phone"></c-input>
                    </m-search-item>
                </m-search>
                <c-table ref="list" height="grow" :paging="true">
                    <c-table-column
                            type="selector"
                            width="32"
                            @handle="batchSelect"
                    ></c-table-column>
                    <c-table-column
                            label="账号"
                            name="user_name"
                            width="100"
                    >
                    </c-table-column>
                    <c-table-column
                            label="姓名"
                            name="user_realname"
                            width="100"
                    >
                    </c-table-column>
                    <c-table-column
                            label="手机号码"
                            name="phone"
                            width="100"
                    >
                    </c-table-column>
                    <c-table-column
                            label="部门名称"
                            name="department_name"
                            width="100"
                    >
                    </c-table-column>
                    <c-table-column
                            label="职务"
                            name="position_name"
                            width="100"
                    >
                    </c-table-column>

                    <c-table-column
                            label="创建人"
                            name="create_user_realname"
                            width="100"
                    >
                        <template #default="{data}">
                            <span v-if="data.is_manage == 1">-</span>
                            <span v-else>{{data.create_user_realname}}</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="创建时间"
                            name="create_date"
                            width="140"
                    ></c-table-column>
                </c-table>
            </module>
        </page>
    </c-dialog>
</template>

<script>
import {batchData, batchMethods} from '@/components/public/batch.js'
export default {
    components: {},
    data() {
        return {
            selectedPersons: [],
            ...batchData()
        }
    },

    mounted() {

    },


    methods: {
        ...batchMethods(),
        /************搜索列表**************/
        searchHandle(data){
            if (!data){
                data = {};
            }
            this.$refs.list.load({
                url: '/sys_user/select_list',
                data
            });
        },
        open() {
            this.selectedPersons = [];
            this.searchKeyword = '';

            this.$refs.dialog.open();
            this.searchHandle();
        },

        confirmSelection(stop, next) {
            this.selectedPersons = this.$refs.list.getData('selected');
            if (this.selectedPersons.length === 0) {
                this.$message({
                    message: '请至少选择一位人员',
                    type: 'warning'
                });
                return;
            }

            if (this.selectedPersons.length > 1) {
                this.$message({
                    message: '只能选择一位人员',
                    type: 'warning'
                });
                return;
            }

            stop();

            const selectedPerson = this.selectedPersons[0];
            this.$emit('confirm', {
                id: selectedPerson.id,
                name: selectedPerson.user_realname,
                department: selectedPerson.department_name,
            });

            next();
        }
    },

    beforeDestroy() {
        clearTimeout(this.searchTimer);
    }
}
</script>

<style lang="stylus" scoped>
.person-selector-container
    display: flex
    flex-direction: column
    height: 100%

.search-area
    margin-bottom: 15px

.person-list
    flex: 1
</style>
